import { resolveComponentVariant } from '../common/componentContract'
import styles from './Layout.module.css'

const sizes = ['narrow', 'default', 'wide', 'full', 'workspace']

export function PageLayout({
  size = 'default',
  children,
  stickyActions,
  stickyActionsClassName = '',
  className = '',
  as: Component = 'div'
}) {
  const resolvedSize = resolveComponentVariant('PageLayout size', size, sizes, 'default')
  return (
    <Component className={`${styles.pageLayout} ${styles[resolvedSize]} ${className}`.trim()} data-page-size={resolvedSize}>
      {children}
      {stickyActions ? (
        <div className={`${styles.stickyActions} ${stickyActionsClassName}`.trim()}>{stickyActions}</div>
      ) : null}
    </Component>
  )
}
